export default function DownloadCTA() {
  return (
    <section id="download" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          {/* Image */}
          <div className="rounded-2xl overflow-hidden mb-8 md:mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20smartphone%20displaying%20entertainment%20news%20app%20interface%2C%20warm%20dramatic%20lighting%2C%20dark%20moody%20background%20with%20crimson%20accents%2C%20modern%20tech%20lifestyle%20photography%2C%20film%20grain%20texture%2C%20premium%20editorial%20style&width=1200&height=600&seq=cta-download-bg&orientation=landscape"
              alt="吃瓜网APP下载"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text */}
          <div className="text-center">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight">
              随时随地，
              <span className="italic text-primary-500">第一时间吃瓜</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-md mx-auto">
              下载吃瓜网APP，推送快人一步，永远不错过任何一个大瓜
            </p>

            {/* Download Button */}
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-lg w-5 h-5 flex items-center justify-center"></i>
                iOS 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-lg w-5 h-5 flex items-center justify-center"></i>
                Android 下载
              </a>
            </div>

            <p className="text-xs text-foreground-500 mt-4">
              已有 <strong>128万+</strong> 用户下载 · 评分 4.8/5.0
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}